<section class="customer-dialog-shell">
  <header class="customer-dialog-header">
    <h2 mat-dialog-title>{{ isNewCustomer ? 'Ny kund' : 'Kund' }}</h2>
    <button mat-icon-button type="button" aria-label="Stäng dialogen" matTooltip="Stäng" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <mat-dialog-content class="customer-dialog-content">

<div *ngIf="!isNewCustomer && !customer.Active">Kund med detta organisationsnummer kan inte användas längre.</div>

<form #personForm="ngForm" novalidate class="customer-form">

  <section *ngIf="isAdmin" class="form-wide customer-admin-settings" aria-label="Kundinställningar">
      <mat-checkbox [(ngModel)]="customer.Global" name="_global" (change)="customer.Global = $event.checked">Global kund</mat-checkbox>
      <mat-checkbox [(ngModel)]="customer.Active" name="_active" (change)="customer.Active = $event.checked">Aktiv</mat-checkbox>
      <mat-checkbox [(ngModel)]="customer.ExpressNotApproved" [disabled]="!customer.Global" name="ExpressNotApproved" aria-describedby="express-block-description">Express ej godkänd</mat-checkbox>
    <p id="express-block-description" style="margin: 0;">Markerad kund visas i spärrlistan även utan inkassoärenden. Inkassoärenden spärrar alltid express</p>
  </section>


  <!--Regular text field shown to admin, and only as text to member-->
  <div *ngIf="isAdmin">
    <mat-form-field subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Info om kunden som syns för medlem</mat-label>
      <input matInput type="text" [(ngModel)]='customer.PublicInfo' [disabled]="!isAdmin" placeholder="Info om kunden som syns för medlem" name="PublicInfo">
    </mat-form-field>
  </div>

  <div *ngIf="isAdmin">
    <mat-form-field subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Info om kunden som enbart syns för admin</mat-label>
      <input matInput type="text" [(ngModel)]='customer.AdminInfo' [disabled]="!isAdmin" placeholder="Info om kunden som enbart syns för admin" name="AdminInfo">
    </mat-form-field>
  </div>

  <p class="form-wide" *ngIf="data.recipientOrganizationOnly">Endast företag med organisationskonto i SAMpoolen kan väljas som mottagare. Betaluppgifterna sparas på ditt kundkort.</p>
  <div class="row form-wide" *ngIf="!data.recipientOrganizationOnly">
    <div class="col-12">
      <span class="bold">Kundtyp: </span>
    </div>
    <div class="col-lg-3">
      <mat-checkbox [(ngModel)]="customer.IsCompany" [disabled]="!isNewCustomer && !isAdmin" name="_isPrivatePerson2" (change)="IsCompanyOnChange(customer,$event.checked)">Företag</mat-checkbox>
    </div>
    <div class="col-lg-3">
      <mat-checkbox [ngModel]="!customer.IsCompany" (ngModelChange)="customer.IsCompany = $event" [disabled]="!isNewCustomer && !isAdmin" name="_isPrivatePerson" (change)="IsCompanyOnChange(customer,!$event.checked)" style="margin-left:15px;">Privatperson</mat-checkbox>
    </div>
  </div>

  <!-- Visa/dölj i fakturaverktygets lista -->
  <div class="row form-wide">
    <div class="col-12">
      <span class="bold">Visa i fakturaverktygets kundlista: </span>
    </div>
    <div class="col-lg-3">
      <mat-checkbox [(ngModel)]="customer.ActiveInList" (change)="customer.ActiveInList = $event.checked;" name="activeInListYes">Ja</mat-checkbox>
    </div>
    <div class="col-lg-3">
      <mat-checkbox [ngModel]="!customer.ActiveInList" (ngModelChange)="customer.ActiveInList = $event" (change)="customer.ActiveInList = !$event.checked;" style="margin-left:15px;" name="activeInListNo">Nej</mat-checkbox>
    </div>
  </div>


  <p *ngIf="!isAdmin && customer.PublicInfo" class="warning-box form-wide">{{ customer.PublicInfo }}</p>


  <div class="form-wide customer-identity-fields">
  <mat-form-field class="customer-country-field" subscriptSizing="dynamic" floatLabel="always" *ngIf="customer.Country.Id != null">
    <mat-label>Land</mat-label>
    <mat-select [disabled]="countrySelectionLocked || (!isNewCustomer && !isAdmin)" name="country"
                [ngModel]="customer?.Country?.Id"
                (ngModelChange)="customer && customer.Country ? (customer.Country.Id = $event) : null; onCountryChange($event, true)" [ngModelOptions]="{standalone: true}" required>
      <mat-option *ngFor="let c of countries" [value]="c.Id">
        {{ c.Name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!--Searchbox only shown to users adding a new business customer-->
  <div class="customer-number-field" *ngIf="customer.IsCompany && isNewCustomer">
    <div style="margin: 0 0 0 0;">
      <mat-form-field subscriptSizing="dynamic" floatLabel="always">
        <mat-label>Organisationsnummer</mat-label>
        <input matInput [(ngModel)]="searchAccountValue"
               (ngModelChange)="orgNumberValidCheck($event)"
               (blur)="!orgNumberValid && !isSearchingCompany && !companySearchFailed && orgNumberValidCheck(searchAccountValue, true)"
               pattern="{{customer?.Country?.VatRegexPattern}}"
               name="searchCompany"
               id="searchCompany"
               type="text">
        <mat-hint align="start">
          {{ orgNumberFormat }}
        </mat-hint>
        <mat-icon *ngIf="orgNumberValid" color="accent" matSuffix matTooltipPosition="before" matTooltip="Företaget kontrollerat hos Hitta.se" style="color:green;">check</mat-icon>
        <mat-icon *ngIf="companySearchFailed && !orgNumberValid && !isSearchingCompany" color="accent" matSuffix matTooltipPosition="before" matTooltip="Företaget kan ej verifieras" style="color:red;">close</mat-icon>
        <mat-progress-spinner *ngIf="isSearchingCompany && customer?.Country?.Name === 'Sverige'" matSuffix mode="indeterminate" diameter="20"></mat-progress-spinner>
      </mat-form-field>

      <span *ngIf="errorMessageOrgnr || noResultMessage" class="errormessage">{{errorMessageOrgnr}} {{noResultMessage}}</span>
    </div>
  </div>

  <!--Regular text field shown to admin, and disabled for users when a customer is once saved-->
  <div class="customer-number-field" *ngIf="customer.IsCompany && (!isNewCustomer || (isAdmin && !isSearchingCompany && (companySearchFailed || noResultMessage)))">
    <mat-form-field subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Organisationsnummer / VAT</mat-label>
      <input matInput type="text" [(ngModel)]='customer.OrgNumber'
             [disabled]="!isNewCustomer && !isAdmin"
             placeholder="NNNNNN-NNNN (10 siffror och bindestreck)"
             [required]="(customer?.Country?.Name === 'Sverige') || (customer?.Country?.VatRegexPattern && customer?.Country?.VatRegexPattern.length > 0)"
             name="OrgNumber">
      <mat-hint *ngIf="isAdmin">Fyll i här om organisationsnumret inte kan hittas.</mat-hint>
    </mat-form-field>
  </div>

  <!--Other form fields are shown when orgnr is added, or if private person customer. Always shown to admin-->
  <!-- Personnummer -->
  <mat-form-field class="customer-number-field" subscriptSizing="dynamic" floatLabel="always"
                  *ngIf="!customer.IsCompany">
    <mat-label>Personnummer</mat-label>
    <input matInput type="text" [disabled]="(!isNewCustomer || customer.OrgNumberLocked) && !isAdmin"
           (ngModelChange)="pNumberValidCheck($event)"
           [(ngModel)]='customer.OrgNumber' placeholder="ÅÅÅÅMMDDNNNN (12 siffror utan bindestreck)" required name="Personnummer">
    <mat-icon *ngIf="!pNrValid && !isNewCustomer && !isSearchingPerson" color="accent" matSuffix matTooltipPosition="before" matTooltip="Personen ej verifierad" style="color:red;">close</mat-icon>
    <mat-progress-spinner *ngIf="isSearchingPerson && customer?.Country?.Name === 'Sverige'" matSuffix mode="indeterminate" diameter="20"></mat-progress-spinner>
  </mat-form-field>
  </div>
  <span *ngIf="isAdmin && customer.AdminInfo" class="errormessage form-wide">{{ customer.AdminInfo }}</span>
  <div *ngIf="errorMessageSpar" class="errormessage form-wide">{{errorMessageSpar}}</div>

  <mat-form-field subscriptSizing="dynamic" class="form-wide" floatLabel="always" *ngIf="isAdmin || orgNumberValid || pNrValid || !isNewCustomer">
    <mat-label>Namn</mat-label>
    <input matInput type="text" [disabled]="customer.NameLocked && !isAdmin"
           [(ngModel)]='customer.Name' required name="name">
  </mat-form-field>


  <span *ngIf="!customer.IsCompany && !pNrValid && errorMessagePnr" class="errormessage form-wide">{{errorMessagePnr}}</span>

  <mat-form-field subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin || pNrValid || orgNumberValid || !isNewCustomer">
    <mat-label>Telefon</mat-label>
    <input matInput type="text" [disabled]="customer.PhoneLocked && !isAdmin" (ngModelChange)="phoneNumberValidCheck($event)"
           [(ngModel)]='customer.Phone' name="Phone">
  </mat-form-field>

  <span *ngIf="errorMessagePhoneNr" class="errormessage form-wide">{{errorMessagePhoneNr}}</span>

  <mat-form-field subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin || pNrValid || orgNumberValid || !isNewCustomer">
    <mat-label>Epost för faktura</mat-label>
    <input matInput type="email" [disabled]="customer.InvoiceEmailLocked && !isAdmin" #correctEmail='ngModel' ngModel [(ngModel)]='customer.InvoiceEmail' name="InvoiceEmail">
    <mat-icon *ngIf="!correctEmail.valid && !customer.InvoiceEmailLocked" matSuffix color="accent">warning</mat-icon>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin && customer.IsCompany">
    <mat-label>Epost för mailin</mat-label>
    <input matInput type="email" ngModel [(ngModel)]='customer.MailinInboxEmail' name="MailinInboxEmail">
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin || pNrValid || orgNumberValid || !isNewCustomer">
    <mat-label>C/o</mat-label>
    <input matInput type="text" [disabled]="customer.CoLocked && !isAdmin" [(ngModel)]='customer.Co' name="Co">
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="form-wide" floatLabel="always" *ngIf="isAdmin || pNrValid || orgNumberValid || !isNewCustomer">
    <mat-label>Gata</mat-label>
    <input matInput type="text" [disabled]="customer.AddressLocked && !isAdmin"
           [(ngModel)]='customer.Address' required name="Address">
  </mat-form-field>

  <mat-form-field class="form-wide" subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin || pNrValid || orgNumberValid || !isNewCustomer">
    <mat-label>Gata 2</mat-label>
    <input matInput type="text" [disabled]="customer.Address2Locked && !isAdmin"
           [(ngModel)]='customer.Address2' name="Address 2">
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin || pNrValid || orgNumberValid || !isNewCustomer">
    <mat-label>Postnummer</mat-label>
    <input matInput type="text" [disabled]="customer.ZipLocked && !isAdmin"
           [(ngModel)]='customer.Zip' required name="Zip">
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin || pNrValid || orgNumberValid || !isNewCustomer">
    <mat-label>Ort</mat-label>
    <input matInput type="text" [disabled]="customer.CityLocked && !isAdmin"
           [(ngModel)]='customer.City' required name="City">
  </mat-form-field>



  <mat-form-field class="form-wide" subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin">
    <mat-label>E-post för fakturadokument (Fortnox)</mat-label>
    <input matInput #fortnoxInboxField type="email" readonly [value]="fortnoxInboxEmail" (click)="fortnoxInboxField.select()">
    <button mat-icon-button matSuffix type="button" aria-label="Kopiera e-postadress för fakturadokument" matTooltip="Kopiera e-postadress" (click)="copyFortnoxInboxEmail(fortnoxInboxField)">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <div *ngIf="customer.IsCompany && (isAdmin || orgNumberValid || !isNewCustomer)" class="form-wide customer-delivery" [class.customer-delivery-admin]="isAdmin">
    <p>Förvald leveransmetod för faktura</p>
    <mat-radio-group name="invoiceSendType" [(ngModel)]="customer.InvoiceSendType">
      <mat-radio-button class="ml-2 radiobuttonmargin" [disabled]="customer.InvoiceSendTypeLocked && !isAdmin" [value]="0">Ingen förvald</mat-radio-button>
      <!--<mat-radio-button class="ml-2 radiobuttonmargin" [disabled]="customer.InvoiceSendTypeLocked && !isAdmin" [value]="2">Post</mat-radio-button>-->
      <mat-radio-button class="ml-2 radiobuttonmargin" [disabled]="customer.InvoiceSendTypeLocked && !isAdmin" [value]="1">E-post (pdf)</mat-radio-button>
      <mat-radio-button class="ml-2 radiobuttonmargin" [disabled]="customer.InvoiceSendTypeLocked && !isAdmin" [value]="3">EDI</mat-radio-button>
    </mat-radio-group>

    <mat-form-field class="customer-gln-field" [class.edi-field-hidden]="isAdmin && customer.InvoiceSendType != 3" subscriptSizing="dynamic" floatLabel="always" *ngIf="isAdmin || (customer.InvoiceSendType == 3 && ((!pNrValid && orgNumberValid) || !isNewCustomer))" appearance="fill">
    <mat-label>GLN-nummer (ej obligatorisk)</mat-label>
    <input matInput type="text" [disabled]="customer.GlnNumberLocked && !isAdmin" [(ngModel)]='customer.GlnNumber' placeholder="GLN-nummer för EDI" name="glnnumber">
    <mat-icon color="accent" matSuffix matTooltipPosition="before" area-label="Hover to display info" matTooltip="GLN-nummer är endast krav när man skickar en EDI (e-faktura), vilket inte ska förväxlas med PDF-faktura via e-post. Man kan förklara GLN-nummer som en adress dit man skickar den elektroniska fakturan. Din kund kan förse dig med den information du behöver.">info</mat-icon>
  </mat-form-field>


    <mat-form-field *ngIf="isAdmin" subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Betalvillkor</mat-label>
      <mat-select [ngModel]="customer.PaymentTerm" (ngModelChange)="customer.PaymentTerm = $event" name="paymentterm">
        <mat-option *ngFor="let item of paymentTerms" [value]="item">{{item}} dagar</mat-option>
      </mat-select>
      <mat-hint>0 dagar = inget förvalt värde</mat-hint>
    </mat-form-field>

    <!--If electronic reference is mandatory-->
    <div *ngIf="customer.InvoiceSendType == 3 && customer.ElectronicReferenceMandatory && !isAdmin" style="margin-bottom: 20px;">
      <mat-form-field subscriptSizing="dynamic" floatLabel="always" appearance="fill">
        <mat-label>Elektronisk referens</mat-label>
        <input matInput type="text" [(ngModel)]='customer.ElectronicReference' name="ereference">
        <mat-icon color="accent" matSuffix matTooltipPosition="before" area-label="Hover to display info" matTooltip="Din kund kräver elektronisk referens på e-fakturor. Oftast är detta en sifferkod, men kan variera. Om du inte fått info från din kund behöver du fråga din kund efter elektronisk referens på e-fakturor.">info</mat-icon>
      </mat-form-field>
      <span style="font-size: 80%; font-style: italic;">Din kund kräver elektronisk referens på e-fakturor. Oftast är detta en sifferkod, men kan variera. Om du inte fått info från din kund behöver du fråga din kund efter elektronisk referens på e-fakturor. Du kan fylla i en referenskod här så att de automatiskt adderas på framtida fakturor (som går att ändra när du skapar en faktura) eller så kan du fylla i informationen när du skapar en faktura.</span>
    </div>


    <!--If electronic reference is not mandatory-->
    <div *ngIf="!isAdmin && customer.InvoiceSendType == 3 && !customer.ElectronicReferenceMandatory">
      <mat-form-field subscriptSizing="dynamic" floatLabel="always" appearance="fill">
        <mat-label>Elektronisk referens</mat-label>
        <input matInput type="text" [(ngModel)]='customer.ElectronicReference' name="ereference">
        <mat-icon color="accent" matSuffix matTooltipPosition="before" area-label="Hover to display info" matTooltip="Din kund kräver elektronisk referens på e-fakturor. Oftast är detta en sifferkod, men kan variera. Om du inte fått info från din kund behöver du fråga din kund efter elektronisk referens på e-fakturor.">info</mat-icon>
      </mat-form-field>
    </div>

    <div *ngIf="!isNewCustomer &&!isAdmin && customer.AcceptsInvoiceFeeLocked && !customer.AcceptsInvoiceFee" class="row" style="margin-bottom: 10px;">
      <div class="col-12">
        <span class="bold">Denna kund godkänner inte att du fakturerar dem för fakturaavgiften.</span>
      </div>
    </div>

    <div *ngIf="isAdmin" class="row customer-admin-setting customer-time-report-setting">
      <div class="col-12">
        <span class="bold">Kunden kräver detaljerad tidrapport: </span>
      </div>
      <div class="col-12">
        <mat-checkbox [disabled]="customer.TimeReportMandatory && !isAdmin" [(ngModel)]="customer.TimeReportMandatory" (change)="customer.TimeReportMandatory = $event.checked;" name="timeyes">Ja</mat-checkbox>
        <mat-checkbox [disabled]="customer.TimeReportMandatory && !isAdmin " [ngModel]="!customer.TimeReportMandatory" (ngModelChange)="customer.TimeReportMandatory = $event" (change)="customer.TimeReportMandatory = !$event.checked;" style="margin-left:15px;" name="timeno">Nej</mat-checkbox>
      </div>
    </div>
    <div *ngIf="isAdmin" class="row customer-admin-setting">
      <div class="col-12">
        <span class="bold">Kunden godkänner fakturaavgift: </span>
      </div>
      <div class="col-12">
        <mat-checkbox [disabled]="customer.AcceptsInvoiceFeeLocked && !isAdmin" [(ngModel)]="customer.AcceptsInvoiceFee" (change)="customer.AcceptsInvoiceFee = $event.checked;" name="yes">Ja</mat-checkbox>
        <mat-checkbox [disabled]="customer.AcceptsInvoiceFeeLocked && !isAdmin " [ngModel]="!customer.AcceptsInvoiceFee" (ngModelChange)="customer.AcceptsInvoiceFee = $event" (change)="customer.AcceptsInvoiceFee = !$event.checked;" style="margin-left:15px;" name="no">Nej</mat-checkbox>
      </div>
    </div>
    <div *ngIf="!isAdmin && customer.TimeReportMandatory" class="row" style="margin-bottom: 10px;">
      <div class="col-12">
        <span class="bold">Denna kund kräver att du anger detaljerad tidrapport på din faktura.</span>
      </div>
    </div>


    <div *ngIf="isAdmin" class="customer-reference-setting">
      <div class="customer-reference-label">
        <span class="bold">Kunden kräver elektronisk referens: </span>
      </div>
      <div class="customer-reference-options">
        <mat-checkbox [(ngModel)]="customer.ElectronicReferenceMandatory" (change)="customer.ElectronicReferenceMandatory = $event.checked;" name="referenceyes">Ja</mat-checkbox>
        <mat-checkbox [ngModel]="!customer.ElectronicReferenceMandatory" (ngModelChange)="customer.ElectronicReferenceMandatory = $event" (change)="customer.ElectronicReferenceMandatory = !$event.checked;" style="margin-left:15px;" name="referenceno">Nej</mat-checkbox>
      </div>
      <div [class.edi-field-hidden]="!customer.ElectronicReferenceMandatory">
      <mat-form-field subscriptSizing="dynamic" floatLabel="always" appearance="fill">
        <mat-label>Elektronisk referens</mat-label>
        <input matInput type="text" [(ngModel)]='customer.ElectronicReference' name="ereference">
        <mat-icon color="accent" matSuffix matTooltipPosition="before" area-label="Hover to display info" matTooltip="Din kund kräver elektronisk referens på e-fakturor. Oftast är detta en sifferkod, men kan variera. Om du inte fått info från din kund behöver du fråga din kund efter elektronisk referens på e-fakturor.">info</mat-icon>
      </mat-form-field>
      </div>
    </div>

  </div>

  <h3 class="form-wide" *ngIf="showPaymentInfo" style="margin: 8px 0 0; font-size:17px; font-weight:700;">{{isAdmin ? 'Betaluppgifter för självfaktura' : 'Betaluppgifter för att betala ut provision'}}</h3>
  <ng-container *ngIf="showPaymentInfo">
    <mat-form-field class="form-wide" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>Betalningssätt</mat-label>
      <mat-select [(ngModel)]="paymentMethod" (ngModelChange)="paymentMethodChanged()" name="paymentMethod">
        <mat-option value="bankgiro">Bankgiro</mat-option>
        <mat-option value="plusgiro">Plusgiro</mat-option>
        <mat-option value="swedish">Svenskt bankkonto</mat-option>
        <mat-option value="international">Utländskt bankkonto</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="paymentMethod === 'bankgiro'" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>Bankgiro</mat-label><input matInput [(ngModel)]="customer.Bankgiro" name="Bankgiro">
    </mat-form-field>
    <mat-form-field *ngIf="paymentMethod === 'plusgiro'" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>Plusgiro</mat-label><input matInput [(ngModel)]="customer.Plusgiro" name="Plusgiro">
    </mat-form-field>
    <mat-form-field *ngIf="paymentMethod === 'swedish'" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>Clearingnummer</mat-label><input matInput [(ngModel)]="customer.ClearingNumber" (ngModelChange)="validatePaymentInfo()" name="ClearingNumber" inputmode="numeric">
    </mat-form-field>
    <mat-form-field *ngIf="paymentMethod === 'swedish'" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>Kontonummer</mat-label><input matInput [(ngModel)]="customer.AccountNumber" (ngModelChange)="validatePaymentInfo()" name="AccountNumber" inputmode="numeric">
    </mat-form-field>
    <mat-form-field *ngIf="paymentMethod === 'international'" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>IBAN</mat-label><input matInput [(ngModel)]="customer.Iban" (ngModelChange)="validatePaymentInfo()" name="Iban">
    </mat-form-field>
    <mat-form-field *ngIf="paymentMethod === 'international'" appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>BIC</mat-label><input matInput [(ngModel)]="customer.Bic" (ngModelChange)="validatePaymentInfo()" name="Bic">
    </mat-form-field>
    <p class="form-wide" *ngIf="paymentMethod === 'swedish' && resolvedPaymentBankName" style="margin:0;">Bank: {{resolvedPaymentBankName}}</p>
    <p class="form-wide errormessage" *ngIf="paymentValidationMessage" role="alert" style="margin:0;">{{paymentValidationMessage}}</p>
    <div class="form-wide" *ngIf="paymentMethod === 'swedish' && bankLoadError">
      <button type="button" mat-stroked-button (click)="loadPaymentBanks()">Försök igen</button>
    </div>
  </ng-container>
</form>
  </mat-dialog-content>

  <footer class="customer-dialog-footer">
  <div class="customer-dialog-actions">
    <button mat-stroked-button type="button" (click)="cancel()">Avbryt</button>
    <button type="button" mat-flat-button color="accent"
            [disabled]="!isAdmin && (!formValid() || (!customer.IsCompany && !pNrValid) || !!paymentValidationMessage)"
            (click)="save(customer)">
      <mat-icon>check</mat-icon>
      Spara
    </button>
  </div>
    <p *ngIf="errorMessage" class="errormessage">{{errorMessage}}</p>
  </footer>
</section>

